import { render, staticRenderFns } from "./StanleyUserMessage.vue?vue&type=template&id=379a6f60&scoped=true"
import script from "./StanleyUserMessage.vue?vue&type=script&lang=js"
export * from "./StanleyUserMessage.vue?vue&type=script&lang=js"
import style0 from "./StanleyUserMessage.vue?vue&type=style&index=0&id=379a6f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379a6f60",
  null
  
)

export default component.exports